<h1 mat-dialog-title>Create folder</h1>

<mat-dialog-content>
  <form class="new-folder">
    <mat-form-field appearance="outline">
      <mat-label>New folder name</mat-label>
      <input matInput [(ngModel)]="data.folder.name" name="folderName">
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!data.folder.name"
          (click)="dialogRef.close(data.folder.name)">Create</button>
</mat-dialog-actions>
